import React, { Component } from 'react';
import axios from 'axios'
import { notification } from 'antd';
import { injectIntl, defineMessages } from 'react-intl';
import '../App.css';
import SMTPServerSettings from '../controls/SMTPServerSettings'
import LoadingControl from '../controls/Loading';
import { sendPost } from '../utils/utils';

const messages = defineMessages({
  success: {
    id: 'Success',
  },  
  success_result: {
    id: 'Success_result',
  },
  error: {
      id: 'Error',
    }, 
});

class SMTPServerPane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      settings: null,
    };
  }

  async getSMTPSettings() {
    const res = await axios("/settings");
    return res.data;
  }

  setSMTPSettings(settings)
  {
    sendPost('/settings', settings, this.props.intl);
  }

  testSMTPSettings(settings)
  {
      axios.post('/test_mail', settings)
      .then(response => {
      if (response.data.error === undefined)
      {
        notification['success']({
          message: this.props.intl.formatMessage(messages.success),
          description: this.props.intl.formatMessage(messages.success_result),
        });
      }
      else
      {
        notification['error']({
          message: this.props.intl.formatMessage(messages.error),
          description: response.data.error.Response,
          duration: 0
        });  
      }
    })
    .catch(err => {
       const error_msg = err.response?.data?.error || err.message || 'Unknown error';

      notification['error']({
        message: this.props.intl.formatMessage(messages.error),
        description: error_msg,
        duration: 0
      });
    });
  }

  update() {
    this.setState({isLoaded: false});

    this.getSMTPSettings()
    .then(res => {
      this.setState({ error: null, isLoaded: true, settings: res });
    })
    .catch(err => {
      console.log(err);
      this.setState( {error: err, isLoaded: false, settings: null });
    });
  }  

  componentDidMount() {
    this.update();
  }
  
    render() {
      if(this.state.error != null)
      {
        return (
          <div><h3>{this.state.error.message}</h3></div>
        );
      }
      else if (!this.state.isLoaded)
      {
        return (
          <div><LoadingControl/></div>
        );
      }
      else
      {
        return (
          <div><SMTPServerSettings smtp_settings={this.state.settings} 
            submit={(settings) => this.setSMTPSettings(settings)}
            test={(settings) => this.testSMTPSettings(settings)}/></div>
        );
      }
  }
}

export default injectIntl(SMTPServerPane, {
  withRef: true,
});